<template>
    <div>
        <simple-modal :show="true" @close="closeModal()" :title="title">
            <div v-if="!showNoSignatures" class="flex flex-col gap-y-4">
                <inspection-signature
                    v-for="signature in signatures"
                    :key="signature.id"
                    :signature="signature"
                    @close="$emit('close')"
                    @show-delete-modal="showDeleteConfirmationModal">
                </inspection-signature>
            </div>

            <div v-if="showNoSignatures" class="flex justify-center text-center items-center h-full w-full">
                No signatures
            </div>
        </simple-modal>

        <confirmation-dialog :show="showDeleteConfirmation" v-if="showDeleteConfirmation && selectedSignature"
                             @proceed="hideDeleteConfirmationModal" @cancelled="hideDeleteConfirmationModal(true)"
                             title="Delete Signature" :subtitle="'The signature made by ' + selectedSignature.signatory_name + ' will be deleted.'"
                             proceed-button-text="Delete" :show-icon="false">
            <template slot="body">
                <div class="mt-2">
                    <input type="text" class="form-control" v-model="confirmDeleteText" placeholder="Type DELETE to confirm">
                </div>
            </template>
        </confirmation-dialog>
    </div>
</template>

<script>
import InspectionSignature from "./InspectionSignature";

export default {
    name: "InspectionSignaturesListModal",

    components: {InspectionSignature},

    props: {
        inspection: {
            type: Object,
            required: true,
        },
    },

    data () {
        return {
            selectedSignature: null,
            showDeleteConfirmation: false,
            confirmDeleteText: "",
            signatures: [],
        };
    },

    watch: {
        inspection (newInspection) {
            if (newInspection) {
                this.signatures = newInspection.signatures;
            }
        }
    },

    mounted () {
        this.signatures = this.inspection.signatures;
    },

    computed: {
        showNoSignatures () {
            return this.signatures?.length <= 0;
        },

        title () {
            if (this.inspection) {
                return "Signatures for " + this.$options.filters.dateDayMonth(this.inspection.date) + " " + this.inspection.type;
            }

            return "Signatures";
        },
    },

    methods: {
        showDeleteConfirmationModal (signature) {
            this.selectedSignature = signature;
            this.showDeleteConfirmation = true;
        },

        hideDeleteConfirmationModal (cancel = false) {
            if (cancel) {
                this.resetDeleteSignature();
                return;
            }

            if (this.confirmDeleteText === "DELETE") {
                this.deleteSignature();
            } else {
                toastr.error("You need to type delete in the text field to confirm!");
            }
        },

        deleteSignature () {
            axios.delete("/inspections/signatures/" + this.selectedSignature.id + "/delete")
            .then(() => {
                let index = this.signatures.findIndex(s => s.id === this.selectedSignature.id);
                if (index !== -1) {
                    this.signatures.splice(index, 1);
                }
                this.$emit("signature-deleted", this.selectedSignature.id, this.inspection);
                toastr.success("Signature deleted!");
                this.resetDeleteSignature();
            })
            .catch(error => {
                this.showDeleteConfirmation = false;
                toastr.error(error.message);
            });
        },

        resetDeleteSignature () {
            this.selectedSignature = null;
            this.confirmDeleteText = "";
            this.showDeleteConfirmation = false;
        },

        closeModal () {
            this.$emit("close");
        }
    },
};
</script>